import { render, staticRenderFns } from "./SectionRecommended.vue?vue&type=template&id=24fcd1ee"
import script from "./SectionRecommended.vue?vue&type=script&lang=js"
export * from "./SectionRecommended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports